import axios from "axios"
import { port } from "../CommonComponents/CommonWorkers";

console.log(process.env.NODE_ENV)
let address = window.location.protocol + "//" + window.location.hostname + port  + "/api"

const isDebug = process.env.NODE_ENV === "development" ? true : false;
if(isDebug) {
    address = "https:" + "//" + "prs1.myproxy.club"  + port
    // address = "https:" + "//" + "localhost" + port
}

export const uploadFile = async (formData) =>{
    const id = (await axios.post(`${address}/fileUpload/uploadFile`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }})).data;
    return id;
}

export const deleteFile = async (id) =>{
    await axios.delete(`${address}/fileUpload/deleteFile/${id}`)
}

export const getUploadTable = async () =>{
    const rows = (await axios.get(`${address}/fileUpload/getUploadTable`)).data;
    return rows;
}
 
export const editRow = async (data) =>{
    const id = (await axios.post(`${address}/fileUpload/updateRow`,
    {
        id: data.ID,
        userDate: data.USER_DATE,
        description: data.DESCRIPTION,
    })).data;
    return id;
}

export const aiProcessing = async (id, prompt) => {
    const content = (await axios.post(`${address}/fileUpload/aiProcessing`, {
        id: id,
        prompt: prompt,
    })).data
    return content;
}

export const hrefStringForFileDownload = `${window.location.protocol}//${window.location.hostname}${port}/fileUpload/downloadFile`
export const hrefStringForFileOpen = `${window.location.protocol}//${window.location.hostname}${port}/fileUpload/openFile`
export const hrefStringForDeleteDownload = `${window.location.protocol}//${window.location.hostname}${port}/fileUpload/deleteFile`